import * as Mod1 from "./discourse/adapters/discourse-reactions-adapter";
import * as Mod2 from "./discourse/adapters/discourse-reactions-custom-reaction";
import * as Mod3 from "./discourse/components/discourse-reactions-actions-button";
import * as Mod4 from "./discourse/components/discourse-reactions-actions-summary";
import * as Mod5 from "./discourse/components/discourse-reactions-actions";
import * as Mod6 from "./discourse/components/discourse-reactions-counter";
import * as Mod7 from "./discourse/components/discourse-reactions-list-emoji";
import * as Mod8 from "./discourse/components/discourse-reactions-list";
import * as Mod9 from "./discourse/components/discourse-reactions-picker";
import * as Mod10 from "./discourse/components/discourse-reactions-reaction-button";
import * as Mod11 from "./discourse/components/discourse-reactions-reaction-emoji";
import * as Mod12 from "./discourse/components/discourse-reactions-users-menu";
import * as Mod13 from "./discourse/connectors/user-activity-bottom/discourse-reactions-user-activity-reactions.gjs";
import * as Mod14 from "./discourse/connectors/user-notifications-bottom/discourse-reactions-user-notification-reactions.gjs";
import * as Mod15 from "./discourse/controllers/user-activity/reactions";
import * as Mod16 from "./discourse/discourse-reactions-user-activity-route-map";
import * as Mod17 from "./discourse/discourse-reactions-user-notifications-route-map";
import * as Mod18 from "./discourse/initializers/discourse-reactions";
import * as Mod19 from "./discourse/initializers/reactions-admin-plugin-configuration-nav";
import * as Mod20 from "./discourse/lib/hidden-post";
import * as Mod21 from "./discourse/models/discourse-reactions-custom-reaction";
import * as Mod22 from "./discourse/routes/user-activity/reactions";
import * as Mod23 from "./discourse/routes/user-notifications/reactions-received";
import * as Mod24 from "./discourse/templates/user-activity/reactions";
const compatModules = {
  "discourse/adapters/discourse-reactions-adapter": Mod1,
  "discourse/adapters/discourse-reactions-custom-reaction": Mod2,
  "discourse/components/discourse-reactions-actions-button": Mod3,
  "discourse/components/discourse-reactions-actions-summary": Mod4,
  "discourse/components/discourse-reactions-actions": Mod5,
  "discourse/components/discourse-reactions-counter": Mod6,
  "discourse/components/discourse-reactions-list-emoji": Mod7,
  "discourse/components/discourse-reactions-list": Mod8,
  "discourse/components/discourse-reactions-picker": Mod9,
  "discourse/components/discourse-reactions-reaction-button": Mod10,
  "discourse/components/discourse-reactions-reaction-emoji": Mod11,
  "discourse/components/discourse-reactions-users-menu": Mod12,
  "discourse/connectors/user-activity-bottom/discourse-reactions-user-activity-reactions": Mod13,
  "discourse/connectors/user-notifications-bottom/discourse-reactions-user-notification-reactions": Mod14,
  "discourse/controllers/user-activity/reactions": Mod15,
  "discourse/discourse-reactions-user-activity-route-map": Mod16,
  "discourse/discourse-reactions-user-notifications-route-map": Mod17,
  "discourse/initializers/discourse-reactions": Mod18,
  "discourse/initializers/reactions-admin-plugin-configuration-nav": Mod19,
  "discourse/lib/hidden-post": Mod20,
  "discourse/models/discourse-reactions-custom-reaction": Mod21,
  "discourse/routes/user-activity/reactions": Mod22,
  "discourse/routes/user-notifications/reactions-received": Mod23,
  "discourse/templates/user-activity/reactions": Mod24,
};
export default compatModules;
